import { useLocation } from 'react-router-dom';
import {
    BreadcrumbDivider,
    BreadcrumbItemLink,
    BreadcrumbsContainer,
} from './Breadcrumbs.styles';
import { Typography } from '../../../../base';
import { useTranslation } from 'react-i18next';

const Breadcrumbs = () => {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const pathnames = location.pathname.split('/').filter((x) => x);

    return (
        <BreadcrumbsContainer aria-label="breadcrumb">
            {pathnames.map((value, index) => {
                const queryParams = new URLSearchParams(location.search);
                const companyKey = queryParams.get('ck') || '';
                const routeTo = `/${pathnames.slice(0, index + 1).join('/')}${companyKey ? `?ck=${companyKey}` : ''}`;
                const isLast = index === pathnames.length - 1;
                const path = decodeURIComponent(value);
                const breadcrumbKey = `breadcrumbs.${path}`;
                const breadcrumbText = i18n.exists(breadcrumbKey)
                    ? t(breadcrumbKey)
                    : path;

                return (
                    <span
                        key={value}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        {isLast ? (
                            <Typography variant="body2" color="textPrimary">
                                {breadcrumbText}
                            </Typography>
                        ) : (
                            <>
                                <BreadcrumbItemLink to={routeTo}>
                                    <Typography
                                        variant="body2"
                                        color="textSecondary"
                                    >
                                        {breadcrumbText}
                                    </Typography>
                                </BreadcrumbItemLink>
                                <BreadcrumbDivider>/</BreadcrumbDivider>
                            </>
                        )}
                    </span>
                );
            })}
        </BreadcrumbsContainer>
    );
};

export default Breadcrumbs;
